/*
 * ed-gallery-thumbs.js
 * Embedded Designz — Permanent Custom Asset
 * Syncs thumbnail strip height to match main product image height
 * for left/right thumbnail layout modes.
 * Referenced from snippets/product-gallery.liquid.
 * Safe: this file will NOT be overwritten when the Stretch theme is updated.
 */

(function () {
  function syncThumbHeight(container) {
    var main = container.querySelector('.relative');
    var thumbList = container.querySelector('.product-gallery__thumbnail-list');
    if (!main || !thumbList) return;
    thumbList.style.maxHeight = main.offsetHeight + 'px';
  }

  function initSync() {
    var containers = document.querySelectorAll(
      '.product-gallery__image-list--thumbs-left, .product-gallery__image-list--thumbs-right'
    );
    containers.forEach(function (container) {
      var main = container.querySelector('.relative');
      if (!main) return;
      syncThumbHeight(container);
      new ResizeObserver(function () {
        syncThumbHeight(container);
      }).observe(main);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSync);
  } else {
    initSync();
  }
})();
